var render = function render(){
  var _vm$lastestEvaluation, _vm$lastestEvaluation2, _vm$lastestEvaluation3, _vm$lastestEvaluation4, _vm$lastestEvaluation5, _vm$lastestEvaluation6, _vm$lastestEvaluation7, _vm$lastestEvaluation8, _vm$lastestEvaluation9, _vm$lastestEvaluation10, _vm$lastestEvaluation11, _vm$lastestEvaluation12;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "flex justify-center my-8 w-full"
  }, [_c('div', {
    staticClass: "flex relative cursor-pointer items-center w-max",
    on: {
      "click": [_vm.displayTypeCompetenceChoice, function ($event) {
        $event.stopPropagation();
      }]
    }
  }, [_c('div', {
    staticClass: "text-xl text-indigo-600"
  }, [_vm._v("\n        " + _vm._s(_vm.typeCompetenceChosen) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "text-pink-600 max-h-8 mr-auto rounded-full inline-flex items-center p-2 order-2"
  }, [(Object.values(_vm.form.items.competences_bases.savoirs).length > 0 || Object.values(_vm.form.items.competences_bases.savoir_faire).length > 0) && (Object.values(_vm.form.items.competences_spe.savoirs).length > 0 || Object.values(_vm.form.items.competences_spe.savoir_faire).length > 0) ? _c('icon', {
    staticClass: "h-4 w-4",
    attrs: {
      "name": "chevron-down"
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm.showTypeCompetenceChoice ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.displayTypeCompetenceChoice,
      expression: "displayTypeCompetenceChoice"
    }],
    staticClass: "absolute flex fieldlist z-20 w-max-content w-max mt-2 top-8 right-0 text-sm rounded-md bg-white shadow-md shadow-gray-600"
  }, [_c('div', {
    staticClass: "mx-5 my-3"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('div', {
    staticClass: "pt-2 pb-1"
  }, [_c('p', {
    staticClass: "text-gray-600 hover:text-gray-900",
    on: {
      "click": function ($event) {
        _vm.typeCompetenceChosen = 'Compétences de base';
      }
    }
  }, [_vm._v("\n                Compétences de base\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "py-1"
  }, [_c('p', {
    staticClass: "text-gray-600 hover:text-gray-900",
    on: {
      "click": function ($event) {
        _vm.typeCompetenceChosen = 'Compétences spécifiques';
      }
    }
  }, [_vm._v("\n                Compétences spécifiques\n              ")])])])])]) : _vm._e()])]), _vm._v(" "), _vm.typeCompetenceChosen === 'Compétences de base' ? _c('div', [_c('rome-evaluation-header', {
    staticClass: "md:mx-10",
    attrs: {
      "can-hide-auto": _vm.evalReferentVisibility && !_vm.historyMode,
      "id-pass": _vm.idPass,
      "id-user": _vm.idUser,
      "is-hidden-value1": _vm.hiddenFields['base_savoir_faire_auto'] && !_vm.historyMode,
      "visibility-value2": _vm.evalReferentVisibility,
      "is-hidden-last-eval": _vm.hiddenFields['base_savoir_faire_last'] && !_vm.historyMode,
      "is-lastest-evaluation-visible": _vm.evalReferentVisibility && !_vm.historyMode
    },
    on: {
      "hideValue1": function ($event) {
        _vm.hiddenFields['base_savoir_faire_auto'] = !_vm.hiddenFields['base_savoir_faire_auto'];
      },
      "hideLastestEvaluation": function ($event) {
        _vm.hiddenFields['base_savoir_faire_last'] = !_vm.hiddenFields['base_savoir_faire_last'];
      }
    }
  }), _vm._v(" "), _c('rome-evaluation-grid', {
    staticClass: "my-4 md:my-8 md:mx-10",
    attrs: {
      "title": "Savoir-Faire",
      "list": _vm.form.items.competences_bases.savoir_faire,
      "lib-keys": ['auto', 'value'],
      "lastest-evaluation": (_vm$lastestEvaluation = _vm.lastestEvaluation) === null || _vm$lastestEvaluation === void 0 ? void 0 : (_vm$lastestEvaluation2 = _vm$lastestEvaluation.items) === null || _vm$lastestEvaluation2 === void 0 ? void 0 : (_vm$lastestEvaluation3 = _vm$lastestEvaluation2.competences_bases) === null || _vm$lastestEvaluation3 === void 0 ? void 0 : _vm$lastestEvaluation3.savoir_faire,
      "is-lastest-evaluation-visible": _vm.evalReferentVisibility && !_vm.historyMode,
      "is-disabled": _vm.isDisabled,
      "is-disabled-value1": !_vm.autoEvalEditable,
      "visibility-value1": _vm.idPass == _vm.idUser || !_vm.hiddenFields['base_savoir_faire_auto'] || _vm.historyMode,
      "visibility-last-eval": !_vm.hiddenFields['base_savoir_faire_last'],
      "visibility-value2": _vm.evalReferentVisibility
    },
    on: {
      "changeValue1": function (infos) {
        _vm.$emit('changeValue', {
          typeCompetence: 'competences_bases',
          typeSavoir: 'savoir_faire',
          evaluatorType: 'auto',
          value: infos
        });
      },
      "changeValue2": function (infos) {
        _vm.$emit('changeValue', {
          typeCompetence: 'competences_bases',
          typeSavoir: 'savoir_faire',
          evaluatorType: 'value',
          value: infos
        });
      }
    }
  }), _vm._v(" "), _c('rome-evaluation-header', {
    staticClass: "md:mx-10",
    attrs: {
      "can-hide-auto": _vm.evalReferentVisibility && !_vm.historyMode,
      "id-pass": _vm.idPass,
      "id-user": _vm.idUser,
      "is-hidden-value1": _vm.hiddenFields['base_savoirs_auto'] && !_vm.historyMode,
      "visibility-value2": _vm.evalReferentVisibility,
      "is-hidden-last-eval": _vm.hiddenFields['base_savoirs_last'] && !_vm.historyMode,
      "is-lastest-evaluation-visible": _vm.evalReferentVisibility && !_vm.historyMode
    },
    on: {
      "hideValue1": function ($event) {
        _vm.hiddenFields['base_savoirs_auto'] = !_vm.hiddenFields['base_savoirs_auto'];
      },
      "hideLastestEvaluation": function ($event) {
        _vm.hiddenFields['base_savoirs_last'] = !_vm.hiddenFields['base_savoirs_last'];
      }
    }
  }), _vm._v(" "), _c('rome-evaluation-grid', {
    staticClass: "my-4 md:my-8 md:mx-10",
    attrs: {
      "title": "Savoirs",
      "list": _vm.form.items.competences_bases.savoirs,
      "lib-keys": ['auto', 'value'],
      "lastest-evaluation": (_vm$lastestEvaluation4 = _vm.lastestEvaluation) === null || _vm$lastestEvaluation4 === void 0 ? void 0 : (_vm$lastestEvaluation5 = _vm$lastestEvaluation4.items) === null || _vm$lastestEvaluation5 === void 0 ? void 0 : (_vm$lastestEvaluation6 = _vm$lastestEvaluation5.competences_bases) === null || _vm$lastestEvaluation6 === void 0 ? void 0 : _vm$lastestEvaluation6.savoirs,
      "is-lastest-evaluation-visible": _vm.evalReferentVisibility && !_vm.historyMode,
      "is-disabled": _vm.isDisabled,
      "is-disabled-value1": !_vm.autoEvalEditable,
      "visibility-value1": _vm.idPass == _vm.idUser || !_vm.hiddenFields['base_savoirs_auto'] || _vm.historyMode,
      "visibility-last-eval": !_vm.hiddenFields['base_savoirs_last'],
      "visibility-value2": _vm.evalReferentVisibility
    },
    on: {
      "changeValue1": function (infos) {
        _vm.$emit('changeValue', {
          typeCompetence: 'competences_bases',
          typeSavoir: 'savoirs',
          evaluatorType: 'auto',
          value: infos
        });
      },
      "changeValue2": function (infos) {
        _vm.$emit('changeValue', {
          typeCompetence: 'competences_bases',
          typeSavoir: 'savoirs',
          evaluatorType: 'value',
          value: infos
        });
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.typeCompetenceChosen === 'Compétences spécifiques' ? _c('div', [_c('rome-evaluation-header', {
    staticClass: "md:mx-10",
    attrs: {
      "can-hide-auto": _vm.evalReferentVisibility && !_vm.historyMode,
      "id-pass": _vm.idPass,
      "id-user": _vm.idUser,
      "is-hidden-value1": _vm.hiddenFields['spe_savoir_faire_auto'] && !_vm.historyMode,
      "visibility-value2": _vm.evalReferentVisibility,
      "is-hidden-last-eval": _vm.hiddenFields['spe_savoir_faire_last'] && !_vm.historyMode,
      "is-lastest-evaluation-visible": _vm.evalReferentVisibility && !_vm.historyMode
    },
    on: {
      "hideValue1": function ($event) {
        _vm.hiddenFields['spe_savoir_faire_auto'] = !_vm.hiddenFields['spe_savoir_faire_auto'];
      },
      "hideLastestEvaluation": function ($event) {
        _vm.hiddenFields['spe_savoir_faire_last'] = !_vm.hiddenFields['spe_savoir_faire_last'];
      }
    }
  }), _vm._v(" "), _c('rome-evaluation-grid', {
    staticClass: "my-4 md:my-8 md:mx-10",
    attrs: {
      "title": "Savoir-Faire",
      "list": _vm.form.items.competences_spe.savoir_faire,
      "lib-keys": ['auto', 'value'],
      "lastest-evaluation": (_vm$lastestEvaluation7 = _vm.lastestEvaluation) === null || _vm$lastestEvaluation7 === void 0 ? void 0 : (_vm$lastestEvaluation8 = _vm$lastestEvaluation7.items) === null || _vm$lastestEvaluation8 === void 0 ? void 0 : (_vm$lastestEvaluation9 = _vm$lastestEvaluation8.competences_spe) === null || _vm$lastestEvaluation9 === void 0 ? void 0 : _vm$lastestEvaluation9.savoir_faire,
      "is-lastest-evaluation-visible": _vm.evalReferentVisibility && !_vm.historyMode,
      "is-disabled": _vm.isDisabled,
      "is-disabled-value1": !_vm.autoEvalEditable,
      "visibility-value1": _vm.idPass == _vm.idUser || !_vm.hiddenFields['spe_savoir_faire_auto'] || _vm.historyMode,
      "visibility-last-eval": !_vm.hiddenFields['spe_savoir_faire_last'],
      "visibility-value2": _vm.evalReferentVisibility
    },
    on: {
      "changeValue1": function (infos) {
        _vm.$emit('changeValue', {
          typeCompetence: 'competences_spe',
          typeSavoir: 'savoir_faire',
          evaluatorType: 'auto',
          value: infos
        });
      },
      "changeValue2": function (infos) {
        _vm.$emit('changeValue', {
          typeCompetence: 'competences_spe',
          typeSavoir: 'savoir_faire',
          evaluatorType: 'value',
          value: infos
        });
      }
    }
  }), _vm._v(" "), _c('rome-evaluation-header', {
    staticClass: "md:mx-10",
    attrs: {
      "can-hide-auto": _vm.evalReferentVisibility && !_vm.historyMode,
      "id-pass": _vm.idPass,
      "id-user": _vm.idUser,
      "is-hidden-value1": _vm.hiddenFields['spe_savoirs_auto'] && !_vm.historyMode,
      "visibility-value2": _vm.evalReferentVisibility,
      "is-hidden-last-eval": _vm.hiddenFields['spe_savoirs_last'] && !_vm.historyMode,
      "is-lastest-evaluation-visible": _vm.evalReferentVisibility && !_vm.historyMode
    },
    on: {
      "hideValue1": function ($event) {
        _vm.hiddenFields['spe_savoirs_auto'] = !_vm.hiddenFields['spe_savoirs_auto'];
      },
      "hideLastestEvaluation": function ($event) {
        _vm.hiddenFields['spe_savoirs_last'] = !_vm.hiddenFields['spe_savoirs_last'];
      }
    }
  }), _vm._v(" "), _c('rome-evaluation-grid', {
    staticClass: "my-4 md:my-8 md:mx-10",
    attrs: {
      "title": "Savoirs",
      "list": _vm.form.items.competences_spe.savoirs,
      "lib-keys": ['auto', 'value'],
      "lastest-evaluation": (_vm$lastestEvaluation10 = _vm.lastestEvaluation) === null || _vm$lastestEvaluation10 === void 0 ? void 0 : (_vm$lastestEvaluation11 = _vm$lastestEvaluation10.items) === null || _vm$lastestEvaluation11 === void 0 ? void 0 : (_vm$lastestEvaluation12 = _vm$lastestEvaluation11.competences_spe) === null || _vm$lastestEvaluation12 === void 0 ? void 0 : _vm$lastestEvaluation12.savoirs,
      "is-lastest-evaluation-visible": _vm.evalReferentVisibility && !_vm.historyMode,
      "is-disabled": _vm.isDisabled,
      "is-disabled-value1": !_vm.autoEvalEditable,
      "visibility-value1": _vm.idPass == _vm.idUser || !_vm.hiddenFields['spe_savoirs_auto'] || _vm.historyMode,
      "visibility-last-eval": !_vm.hiddenFields['spe_savoirs_last'],
      "visibility-value2": _vm.evalReferentVisibility
    },
    on: {
      "changeValue1": function (infos) {
        _vm.$emit('changeValue', {
          typeCompetence: 'competences_spe',
          typeSavoir: 'savoirs',
          evaluatorType: 'auto',
          value: infos
        });
      },
      "changeValue2": function (infos) {
        _vm.$emit('changeValue', {
          typeCompetence: 'competences_spe',
          typeSavoir: 'savoirs',
          evaluatorType: 'value',
          value: infos
        });
      }
    }
  })], 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }